<template>
  <v-row>
    <v-col>
      <v-row justify="center">
        <v-col>
          <v-row>
            <v-col>
              <h2 class="text-center">
                Här skapar ni nya bedömningar/lägger till nya språk
              </h2>
            </v-col>
          </v-row>
          <v-row justify="space-around" v-if="!loading">
            <v-col cols="4">
              <v-form ref="save">
                <v-row justify="center">
                  <p class="text-center">
                    <strong>
                      Inställningar för nuvarande bedömning
                    </strong>
                  </p>
                </v-row>
                <v-row>
                  <v-text-field
                    v-model="filename"
                    label="filnamn"
                    hint="filnamnet är enbart för att organisera bedömningar och har ingen betydelse på resultatet"
                    :rules="obligatorisk"
                    outlined
                  ></v-text-field>
                </v-row>
                <v-row>
                  <v-select
                    v-model="assessment.type"
                    label="Bedömning typ"
                    hint="Vilken typ av bedömning är detta?"
                    :items="types"
                    :rules="obligatorisk"
                    outlined
                  >
                  </v-select>
                </v-row>
                <v-row>
                  <v-select
                    v-model="assessment.lang"
                    label="Språk"
                    hint="Vilket språk är denna bedömning i?"
                    :items="langs"
                    :rules="obligatorisk"
                    outlined
                  >
                  </v-select>
                </v-row>
                <v-row>
                  <v-checkbox
                    v-model="assessment.rtl"
                    label="Höger till vänster?"
                  ></v-checkbox>
                </v-row>
                <v-row>
                  <v-col v-if="!assessment.assessment">
                    <v-btn color="primary" @click="openNew">Öppna ny</v-btn>
                  </v-col>
                  <v-row class="" v-else>
                    <v-col class=" d-flex justify-center">
                      <v-btn color="primary" @click="save">Spara</v-btn>
                    </v-col>
                    <v-col class=" d-flex justify-center">
                      <v-btn color="primary" @click="exportData"
                        >Exportera</v-btn
                      >
                    </v-col>
                  </v-row>
                </v-row>
              </v-form>
            </v-col>
            <v-col cols="4">
              <v-form ref="getfield">
                <v-row>
                  <p class="text-center">
                    <strong>
                      Hämta bedömning
                    </strong>
                  </p>
                </v-row>
                <v-row>
                  <v-select
                    :items="assessments"
                    v-model="assessmentRef"
                    label="Bedömning"
                    :rules="obligatorisk"
                    outlined
                  ></v-select>
                </v-row>
                <v-row>
                  <v-col>
                    <v-btn color="primary" @click="openSaved"
                      >Öppna Sparad</v-btn
                    >
                  </v-col>
                </v-row>
              </v-form>
            </v-col>
          </v-row>
          <v-row v-else justify="center" align="center">
            <v-col class="d-flex justify-center">
              <v-progress-circular
                indeterminate
                color="primary"
              ></v-progress-circular>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
      <v-row class="fill-height" justify="center" v-if="assessment.assessment">
        <v-col cols="12" md="10" lg="8" xl="6">
          <CreateSkill v-model="assessment.assessment" />
        </v-col>
      </v-row>
      <v-row></v-row>
    </v-col>
  </v-row>
</template>

<script>
import CreateSkill from "./components/CreateAssessment/CreateAssessmentSkill";
import langItems from "@/common/languages.js";
import { db } from "@/common/firebase.js";

const Assessment1 = () => {
  return import("@/common/Assessment1.js");
};
const Assessment3 = () => {
  return import("@/common/Assessment3.js");
};

export default {
  name: "CreateAssessment",
  props: {},
  components: {
    CreateSkill
  },
  data() {
    return {
      loading: false,
      obligatorisk: [v => !!v || "Obligatorisk"],
      assessment: {},
      filename: "",
      types: [
        { text: "Del 1", value: "D1" },
        { text: "Del 3", value: "D3" }
      ],
      langs: langItems,
      assessments: [],
      assessmentRef: ""
    };
  },
  methods: {
    openNew() {
      switch (this.assessment.type) {
        case "D1":
          this.loading = true;
          Assessment1().then(data => {
            this.$set(this.assessment, "assessment", data.default);
            this.loading = false;
          });
          break;
        case "D3":
          this.loading = true;
          Assessment3().then(data => {
            this.$set(this.assessment, "assessment", data.default);

            this.loading = false;
          });
          break;
        default:
          window.alert("Ingen typ är vald");
          break;
      }
    },
    openSaved() {
      if (this.$refs.getfield.validate()) {
        this.loading = true;
        const document = this.assessmentRef.split("@");
        let collection;

        if (document[1] === "databas") {
          collection = "assessments";
        } else {
          collection = "saved";
        }
        db.collection(collection)
          .doc(document[0].trim())
          .get()
          .then(ref => {
            var assessm = ref.data();
            Object.keys(assessm.assessment).forEach(skill => {
              Object.keys(assessm.assessment[skill]).forEach(level => {
                if (level !== "rough")
                  assessm.assessment[skill][level].forEach((q, i) => {
                    if (Object.prototype.hasOwnProperty.call(q, "content")) {
                      delete assessm.assessment[skill][level][i].content;
                      assessm.assessment[skill][level][i]["extracontent"] = [];
                      console.log(q);
                    }
                  });
              });
            });

            this.assessment = assessm;

            this.filename = ref.id;
            this.loading = false;
          });
      }
    },
    save() {
      if (this.$refs.save.validate()) {
        if (!this.assessments.includes(this.filename + " @sparad")) {
          db.collection("saved")
            .doc(this.filename)
            .set(this.assessment);
          this.getDocs();
        } else if (window.confirm(`Spara över ${this.filename}?`)) {
          db.collection("saved")
            .doc(this.filename)
            .set(this.assessment);
          this.getDocs();
        }
      }
    },
    exportData() {
      const data = JSON.stringify(this.assessment);
      const blob = new Blob([data], { type: "text/plain" });
      const e = document.createEvent("MouseEvents");
      const a = document.createElement("a");
      a.download = this.filename + ".json";
      a.href = window.URL.createObjectURL(blob);
      a.dataset.downloadurl = ["text/json", a.download, a.href].join(":");
      e.initEvent(
        "click",
        true,
        false,
        window,
        0,
        0,
        0,
        0,
        0,
        false,
        false,
        false,
        false,
        0,
        null
      );
      a.dispatchEvent(e);
    },
    getDocs() {
      this.assessments.splice(0, this.assessments.length);
      db.collection("assessments").onSnapshot(snapshot => {
        snapshot.forEach(doc => {
          this.assessments.push(doc.id + " @databas");
        });
      });
      db.collection("saved").onSnapshot(snapshot => {
        snapshot.forEach(doc => {
          this.assessments.push(doc.id + " @sparad");
        });
      });
    }
  },
  created() {
    this.getDocs();
  }
};
</script>

<style scoped></style>
